export default "__VITE_ASSET__BZ2_dePX__"